import Vue from 'vue';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import locales from './assets/locales';

Vue.use(VueI18Next);

i18next.init({
    lng: 'de',
    fallbackLng: 'de',
    joinArrays: '\n',
    resources: {
        de: { ...locales.de },
        fr: { ...locales.fr },
        it: { ...locales.it },
    },
    interpolation: {
        prefix: '{',
        suffix: '}',
    },
});

const i18n = new VueI18Next(i18next);

export default i18n;
